.container {
    padding: 8px 16px;
    border-radius: 3px;
    border: 1px solid var(--off-white-dk);
}
